import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { TranslateModule } from "@ngx-translate/core";
import { EditCourseComponent } from "./edit-course.component";

@NgModule({
  declarations: [
    EditCourseComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    TranslateModule
  ],
  exports: [
    EditCourseComponent
  ]
})
export class EditCourseModule { }